import { render, staticRenderFns } from "./MobileTable.vue?vue&type=template&id=72986da2&"
import script from "./MobileTable.vue?vue&type=script&lang=js&"
export * from "./MobileTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports